<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
  <path
    d="M5 5H15L19 9V19C19 19.5523 18.5523 20 18 20H6C5.44772 20 5 19.5523 5 19V5Z"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linejoin="round"
  />
  <path d="M9 5V9H15V5" stroke="currentColor" stroke-width="1.75" stroke-linejoin="round" />
  <path d="M8 14H16V20H8V14Z" stroke="currentColor" stroke-width="1.75" stroke-linejoin="round" />
</svg>
